var BaseTokenProvider = function() {
};

BaseTokenProvider.prototype = { 

    getSupportedTokens: function() {
        return [];
    },

    resolveHTMLToken: function(mapObject, token, field, defaultValue) {
        return this.resolveTextToken(mapObject, token, field, defaultValue);
    },

    resolveRichTextToken: function(mapObject, token, field, defaultValue) {
        return this.resolveTextToken(mapObject, token, field, defaultValue);
    },

    resolveTextToken: function(mapObject, token, field, defaultValue) {
        return defaultValue;
    }
};

export default BaseTokenProvider;
